var map = {
	"./background1.webp": "8205",
	"./background2.webp": "a46c",
	"./background3.webp": "4da0",
	"./bootstrap.webp": "c5f0",
	"./css.webp": "4380",
	"./docker.webp": "fd4d",
	"./github.webp": "164f",
	"./githubactions.webp": "5f85",
	"./gmail.webp": "9556",
	"./html.webp": "66e4",
	"./js.webp": "46f1",
	"./linkedin.webp": "ff2d",
	"./profilePic.webp": "30cc",
	"./project_screenshot_1.webp": "c3ce",
	"./project_screenshot_2.webp": "fa51",
	"./project_screenshot_3.webp": "aafb",
	"./sass.webp": "3eb0",
	"./tailwindcss.webp": "317c",
	"./typescript.webp": "ac92",
	"./vitejs.webp": "b0ec",
	"./vitest.webp": "f19b",
	"./vue.webp": "9e0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac27";